  angular
   .module('vppApp')
   .factory('EndDateService', EndDateService);
 EndDateService.$inject = ['$rootScope', 'vppConfig'];

 function EndDateService($rootScope, vppConfig) {
  var EndDateService = {};
  EndDateService.getEndDates = function(programDetails){
    var conDate = [];
    var dealDate = [];
    var bonusDate = [];
    for(var key in programDetails){
      if(programDetails[key].programType === 'Consumer Cash'){
        conDate.push(programDetails[key].endDate);
      }else if(programDetails[key].programType === 'Dealer Cash'){
        dealDate.push(programDetails[key].endDate);
      }else if(programDetails[key].programType === 'Bonus Cash'){
        bonusDate.push(programDetails[key].endDate);
      }
    }
    bonusDate = bonusDate.unique().sort();
    dealDate = dealDate.unique().sort();
    conDate = conDate.unique().sort();
    if(bonusDate[0] <= dealDate[0] || (dealDate[0] === undefined)){
      $rootScope.cashOfferEndDate = bonusDate[0];
    }else {
      $rootScope.cashOfferEndDate = dealDate[0];
    }
    if(conDate[0] <= $rootScope.cashOfferEndDate){
      $rootScope.cashOfferEndDate = conDate[0];
    }
    var cutIt = $rootScope.cashOfferEndDate.split(/\//);
    $rootScope.cashOfferEndDate = [ cutIt[1], cutIt[2], cutIt[0] ].join('/');
  };
  return EndDateService;
}